import React, { FC } from 'react';
import { parseISO } from 'date-fns';
import { map } from 'lodash';
import { t } from '@lingui/macro';
import { Box, Text, Icon, IconSize } from '@bechtel/gds';
import { useName, RestrictTo, useDate, TextWithEllipsis } from '@bechtel/client-common';
import { CrewMember, RodRequest, RodRequestStatusCode } from '@bechtel/types';
import { AvatarGroupStyled, ExpiredStyled, StencilRodContainerStyled } from './styled';
import { RodRequestStatusStyled } from '~/request/styled';

export interface StencilRodRequestItemProps {
  rodRequest: RodRequest;
  onViewRodRequest: (rodRequest: RodRequest) => void;
  isSelected: boolean;
}
export const StencilRodRequestItem: FC<StencilRodRequestItemProps> = ({ isSelected, rodRequest, onViewRodRequest }) => {
  const { getFullName } = useName();
  const { formatRelativeInWords } = useDate();

  const getStencils = (stencils: CrewMember[]) => {
    return map(stencils, (stencilItem: CrewMember) => {
      return {
        src: stencilItem?.imageUrl ? stencilItem?.imageUrl : '',
        alt: getFullName(
          stencilItem?.firstName ? stencilItem?.firstName : ' ',
          stencilItem?.lastName ? stencilItem?.lastName : ' '
        ),
      };
    });
  };
  return (
    <StencilRodContainerStyled
      onClick={(e) => {
        e.preventDefault();
        onViewRodRequest(rodRequest);
      }}
      data-testid="stencil-rod-container"
      isRequestExpired={rodRequest?.currentStatusI18n === RodRequestStatusCode.EXPIRED}
      isSelected={isSelected}
    >
      <RodRequestStatusStyled status={rodRequest.currentStatusI18n} data-testid="rod-request-card" />
      <Box flexDirection={{ sm: 'column' }}>
        <TextWithEllipsis
          size="300"
          family="graphik"
          color="grey.600"
          data-testid="request-card-date"
          style={{ fontStyle: 'italic' }}
        >
          {rodRequest?.weldProcedure.procedure}
        </TextWithEllipsis>
        <Box mb={{ sm: '300' }}>
          <TextWithEllipsis
            data-testid="rod-request-name"
            family="graphik"
            size="500"
            transform="uppercase"
            color="grey.1000"
            weight="600"
          >
            {rodRequest?.requestNumber}
          </TextWithEllipsis>
        </Box>
        <Box pb={{ sm: '200' }}>
          <Text color="blue.700" size="300" weight="800" data-testid="rod-Request-weld-count">
            {rodRequest.welds?.length}&nbsp;
            <Text size="300" weight="400" color="blue.700">
              {rodRequest.welds?.length > 1 ? t`Welds` : t`Weld`}
            </Text>
          </Text>
        </Box>
      </Box>
      <Box alignItems={{ sm: 'center' }}>
        <AvatarGroupStyled data-testid="stencils-avatar-group" data={getStencils(rodRequest?.stencils)} />
      </Box>
      <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'flex-end' }} data-testid="create-date">
        <Text size="300">
          {formatRelativeInWords(parseISO(rodRequest?.pickUpTime), new Date(), RestrictTo.Day, 'HH:mm aa', ``, true)}
        </Text>
        {rodRequest?.currentStatusI18n === RodRequestStatusCode.EXPIRED && (
          <ExpiredStyled>
            {/**Exclamation symbol is coming red color not white as see in GDS so it not matched with design */}
            <Icon icon="exclamation-circle" fillColor="bechtel.red" size={IconSize.MEDIUM} />
          </ExpiredStyled>
        )}
      </Box>
    </StencilRodContainerStyled>
  );
};
